import {getSiteUrl} from "@/helpers/functions";

export interface SeoSchemaWebSiteProps {
    name?: string;
    searchUrlTemplate?: string;
}

export function SeoSchemaWebSite({
                                     name = "ACTIVE Vapor Devices",
                                     searchUrlTemplate,
                                 }: SeoSchemaWebSiteProps = {}) {
    const siteUrl = getSiteUrl();
    const schema: Record<string, unknown> = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "@id": `${siteUrl}/#website`,
        "url": siteUrl,
        "name": name,
        "publisher": {"@id": `${siteUrl}/#organization`},
        "inLanguage": "en-US",
    };

    if (searchUrlTemplate) {
        schema.potentialAction = {
            "@type": "SearchAction",
            "target": {
                "@type": "EntryPoint",
                "urlTemplate": searchUrlTemplate,
            },
            "query-input": "required name=search_term_string",
        };
    }

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
        />
    );
}
